export default {
  TOP_RIGHT: 'tr',
  TOP: 't',
  TOP_LEFT: 'tr',
  RIGHT: 'r',
  CENTER: 'c',
  LEFT: 'l',
  BOTTOM_RIGHT: 'br',
  BOTTOM: 'b',
  BOTTOM_LEFT: 'bl',
};



// WEBPACK FOOTER //
// ./src/widget/player-widget/constants/poster-position.js